export default {
  "hero.badge": "Niezależny zasób • Regularnie aktualizowany • Zorientowany na bezpieczeństwo",
  "hero.title": "USFans Spreadsheet — poznaj twórców, przewodniki i zasoby USFans",
  "hero.subtitle": "Przeglądaj ustrukturyzowany arkusz USFans i centrum zasobów, które pomoże Ci odkrywać informacje o twórcach, porównywać zasoby, rozumieć koszty wysyłki i znajdować przydatne przewodniki w jednym miejscu.",
  "hero.ctaPrimary": "Przeglądaj USFans Spreadsheet",
  "hero.ctaSecondary": "Przeglądaj przewodniki USFans",
  "hero.trust": "Niezależny zasób • Regularnie aktualizowany • Zorientowany na bezpieczeństwo",

  "heroSupport.title": "Szukasz prostszego sposobu na przeglądanie informacji o USFans?",
  "heroSupport.body": "Nasz USFans Spreadsheet porządkuje przydatne informacje w przejrzystą strukturę. Przeglądaj kategorie, przewodniki, porównania, FAQ i praktyczne zasoby z jednego centralnego miejsca.",
  "heroSupport.cta": "Otwórz USFans Spreadsheet",

  "value.title": "Wszystko, co musisz wiedzieć o USFans w jednym miejscu",
  "value.subtitle": "Sześć kluczowych zasobów, uporządkowanych dla szybszych i bezpieczniejszych poszukiwań.",
  "value.spreadsheet.title": "USFans Spreadsheet",
  "value.spreadsheet.body": "Przeglądaj ustrukturyzowane informacje dzięki łatwemu w nawigacji zasobowi w formie arkusza.",
  "value.directory.title": "Katalog twórców",
  "value.directory.body": "Przeglądaj zasoby i kategorie związane z twórcami w przejrzystym widoku.",
  "value.reviews.title": "Recenzje USFans",
  "value.reviews.body": "Zrozum, na co zwracać uwagę, oceniając USFans i powiązane usługi.",
  "value.shipping.title": "Wysyłka i koszty",
  "value.shipping.body": "Poznaj przewodniki dotyczące wysyłki, magazynu i kosztów, aby zaplanować zakupy.",
  "value.coupons.title": "Kupony i rabaty",
  "value.coupons.body": "Znajdź informacje o kuponach, kodach rabatowych i promocjach.",
  "value.safety.title": "Centrum bezpieczeństwa",
  "value.safety.body": "Dowiedz się, jak rozpoznawać podejrzane linki i chronić swoje dane.",

  "spreadsheet.title": "USFans Spreadsheet",
  "spreadsheet.body": "USFans Spreadsheet to kluczowy zasób witryny USFansLink.wiki. Porządkuje on przydatne informacje o twórcach i zasobach w ustrukturyzowany format, dzięki czemu odwiedzający mogą przeglądać, porównywać i odkrywać informacje efektywniej.",
  "spreadsheet.colCreator": "Twórca / Zasób",
  "spreadsheet.colCategory": "Kategoria",
  "spreadsheet.colType": "Typ",
  "spreadsheet.colInfo": "Informacja",
  "spreadsheet.colUpdated": "Aktualizacja",
  "spreadsheet.rowTypeProfile": "Profil",
  "spreadsheet.rowTypeGuide": "Przewodnik",
  "spreadsheet.rowTypeResource": "Zasób",
  "spreadsheet.view": "Zobacz zasób",
  "spreadsheet.cta": "Przeglądaj pełny USFans Spreadsheet →",
  "spreadsheet.group.footwear": "Obuwie",
  "spreadsheet.group.apparel": "Odzież",
  "spreadsheet.group.accessories": "Akcesoria",
  "spreadsheet.group.other": "Inne",

  "search.title": "Popularne wyszukiwania USFans",
  "search.subtitle": "Przejdź do tematów, których ludzie szukają najczęściej.",
  "search.review.title": "Recenzja USFans",
  "search.review.body": "Na co zwrócić uwagę, zanim zaufasz zasobowi USFans.",
  "search.shipping.title": "Koszt wysyłki USFans",
  "search.shipping.body": "Praktyczne spojrzenie na wysyłkę, metody i czas dostawy.",
  "search.coupon.title": "Kupon USFans",
  "search.coupon.body": "Gdzie szukać kuponów i czego się spodziewać.",
  "search.discount.title": "Kod rabatowy USFans",
  "search.discount.body": "Jak działają kody rabatowe i jak je weryfikować.",
  "search.warehouse.title": "Magazyn USFans",
  "search.warehouse.body": "Poznaj proces magazynowy i jego rolę.",
  "search.legit.title": "Czy USFans jest wiarygodne?",
  "search.legit.body": "Zbalansowany przewodnik po bezpiecznej ocenie wiarygodności.",

  "compare.title": "Porównanie zasobów USFans",
  "compare.colResource": "Zasób",
  "compare.colBestFor": "Najlepszy do",
  "compare.colGuides": "Przewodniki",
  "compare.colComparison": "Porównanie",
  "compare.colSafety": "Bezpieczeństwo",
  "compare.rowSpreadsheet": "USFans Spreadsheet",
  "compare.rowSpreadsheetBest": "Uporządkowane przeglądanie",
  "compare.rowDirectory": "Katalog twórców",
  "compare.rowDirectoryBest": "Odkrywanie",
  "compare.rowShipping": "Przewodnik wysyłki",
  "compare.rowShippingBest": "Badanie wysyłki",
  "compare.rowReview": "Przewodnik recenzji",
  "compare.rowReviewBest": "Ocena",

  "how.title": "Jak działa centrum zasobów USFans",
  "how.subtitle": "Prosty czteroetapowy proces bezpiecznego researchu.",
  "how.step1.title": "Odkrywaj",
  "how.step1.body": "Znajdź USFans Spreadsheet lub konkretny temat.",
  "how.step2.title": "Porównuj",
  "how.step2.body": "Użyj przewodników i tabel, aby zrozumieć różnice.",
  "how.step3.title": "Weryfikuj",
  "how.step3.body": "Sprawdź informacje o bezpieczeństwie przed odwiedzeniem zewnętrznych stron.",
  "how.step4.title": "Kontynuuj",
  "how.step4.body": "Odwiedź główną stronę, gdy dodatkowe zasoby będą istotne.",
  "how.cta": "Przeglądaj USFans Spreadsheet",

  "trust.title": "Stworzone dla lepszego researchu USFans",
  "trust.subtitle": "Jasne standardy, przejrzyste informacje i uczciwe wskazówki.",
  "trust.item1": "Niezależna platforma zasobów",
  "trust.item2": "Treści redakcyjne",
  "trust.item3": "Jasne daty aktualizacji",
  "trust.item4": "Wskazówki bezpieczeństwa",
  "trust.item5": "Przejrzyste zastrzeżenie",
  "trust.item6": "Brak fałszywych recenzji",
  "trust.item7": "Brak zmyślonych statystyk",
  "trust.about": "O nas",
  "trust.editorial": "Polityka redakcyjna",
  "trust.update": "Polityka aktualizacji",
  "trust.safetyLink": "Centrum bezpieczeństwa",

  "faq.title": "Często zadawane pytania",
  "faq.subtitle": "Szybkie odpowiedzi na najczęstsze pytania o USFans Spreadsheet.",
  "faq.q1": "Czym jest arkusz USFans?",
  "faq.a1": "Arkusz USFans to ustrukturyzowany zasób, który porządkuje informacje o twórcach, kategoriach i odniesienia w jeden łatwy do przeglądania format.",
  "faq.q2": "Jak działa arkusz USFans?",
  "faq.a2": "Grupuje powiązane informacje w wiersze i kategorie, dzięki czemu możesz je przeglądać, porównywać i przechodzić do istotnych zasobów bez otwierania wielu oddzielnych stron.",
  "faq.q3": "Jakie informacje mogę znaleźć?",
  "faq.a3": "Możesz znaleźć odniesienia do twórców, linki kategorii, przewodniki i praktyczne zasoby związane z przeglądaniem treści USFans.",
  "faq.q4": "Czy USFans jest wiarygodne?",
  "faq.a4": "Oferujemy wskazówki, jak oceniać wiarygodność, zamiast wydawać jeden werdykt. Zawsze weryfikuj źródła i unikaj podejrzanych linków.",
  "faq.q5": "Ile kosztuje wysyłka USFans?",
  "faq.a5": "Koszty wysyłki mogą się różnić w zależności od regionu, metody i zamówienia. Sprawdź najnowsze szczegóły na głównej stronie przed zakupem.",
  "faq.q6": "Czy USFans oferuje kupony?",
  "faq.a6": "Kupony i promocje mogą pojawiać się od czasu do czasu. Zalecamy weryfikację aktualnej oferty bezpośrednio na głównej stronie.",
  "faq.q7": "Czym jest kod rabatowy USFans?",
  "faq.a7": "Kod rabatowy to krótki tekst wpisywany przy kasie, aby zastosować promocję. Zawsze potwierdź, że kod jest aktualny przed użyciem.",
  "faq.q8": "Jak działa magazyn USFans?",
  "faq.a8": "Magazyn zajmuje się przechowywaniem i wysyłką zamówień. Czas realizacji może zależeć od lokalizacji i dostępności towaru.",
  "faq.q9": "Jak oceniać recenzje USFans?",
  "faq.a9": "Szukaj spójnych, szczegółowych opinii z wielu źródeł, zamiast polegać na pojedynczej opinii lub ocenie.",
  "faq.q10": "Czy USFansLink.wiki jest oficjalnie powiązane z USFans?",
  "faq.a10": "Nie. USFansLink.wiki jest niezależnym zasobem informacyjnym i nie jest powiązane ani wspierane przez USFans.",

  "finalCta.title": "Zacznij przeglądać USFans Spreadsheet",
  "finalCta.body": "Przeglądaj ustrukturyzowane zasoby, przewodniki, porównania i informacje o bezpieczeństwie z jednego centralnego miejsca.",
  "finalCta.primary": "Przeglądaj USFans Spreadsheet",
  "finalCta.secondary": "Odwiedź główną stronę",

  "pillar.title": "Przewodniki i zasoby USFans",
  "pillar.subtitle": "Oryginalne, szczegółowe przewodniki obejmujące recenzje, wysyłkę, kupony, bezpieczeństwo i więcej.",
  "pillar.readMore": "Czytaj przewodnik",
};